@if ('showLinkToFaq' | feature | async) {
	@if (user()) {
		<div>
			<a [routerLink]="('frame.footer.faq.filename' | msgKey) + (user().uiLanguage) + '.pdf'"
			   target="_blank">
				{{"frame.footer.faq" | msgKey}}
			</a>
		</div>
	}
}
